/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

/// <reference types="../vite-env.d.ts" />

// Plugins
import { registerPlugins } from './plugins/';

// Components
import App from './App.vue';
import * as Sentry from '@sentry/vue';

// Composables
import { createApp } from 'vue';

const app = createApp(App);

const sentryEnv = window.location.origin.endsWith('.io')
  ? 'staging'
  : 'production';
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN ?? null,
  environment: sentryEnv,
});

const user = JSON.parse(localStorage.getItem('user') ?? '{}');
Sentry.setUser(user);

registerPlugins(app);

app.mount('#app');
